function initDonationWidget(widget) {
  const cta = widget.querySelector("[data-donate-cta]");
  const ctaLabel = widget.querySelector("[data-donate-cta-label]");
  if (!cta) return;

  const originalLabel = ctaLabel ? ctaLabel.textContent : "";
  const customInput = widget.querySelector(".donation_custom_input");
  const customLabel = widget.querySelector(".donation_amount_custom");

  function getActiveButton() {
    const visibleGrid = widget.querySelector(
      ".donation_widget_grid:not([hidden])",
    );
    if (!visibleGrid) return null;
    return visibleGrid.querySelector(".donation_amount.active");
  }

  function activateButton(btn) {
    const grid = btn.closest(".donation_widget_grid");
    if (!grid) return;
    grid
      .querySelectorAll(".donation_amount")
      .forEach((b) => b.classList.remove("active"));
    btn.classList.add("active");
  }

  function setLoading(text) {
    cta.classList.add("loading");
    cta.setAttribute("aria-busy", "true");
    cta.setAttribute("aria-disabled", "true");
    if (ctaLabel) ctaLabel.textContent = text || "Loading...";
  }

  function clearLoading() {
    cta.classList.remove("loading");
    cta.removeAttribute("aria-busy");
    cta.removeAttribute("aria-disabled");
    if (ctaLabel) ctaLabel.textContent = originalLabel;
  }

  // CTA click — routes to either custom (PHP endpoint) or preset (/cart/add.js) flow
  cta.addEventListener("click", async function (e) {
    e.preventDefault();
    if (cta.classList.contains("loading")) return;

    const activeBtn = getActiveButton();
    if (!activeBtn) return;

    const visibleGrid = widget.querySelector(
      ".donation_widget_grid:not([hidden])",
    );
    const variantId = activeBtn.dataset.variantId;
    const sellingPlan = activeBtn.dataset.sellingPlan;
    const isCustom = activeBtn.dataset.custom === "true";
    const campaign =
      visibleGrid.dataset.grid === "monthly"
        ? activeBtn.getAttribute("aria-label").replace("Subscribe: ", "")
        : widget.querySelector(".donation_widget_title")?.textContent ||
          "Donation";

    // ============ CUSTOM AMOUNT FLOW ============
    if (isCustom) {
      const amount = parseInt(customInput?.value, 10);

      if (!amount || isNaN(amount) || amount < 1) {
        alert("Please enter an amount of at least £1");
        customInput?.focus();
        return;
      }

      if (amount > 50000) {
        alert("Maximum donation amount is £50,000");
        customInput?.focus();
        return;
      }

      if (!window.donationApiUrl) {
        console.error("donationApiUrl not configured in Liquid");
        alert(
          "Custom donations are not available right now. Please pick a preset amount.",
        );
        return;
      }

      if (!variantId) {
        console.error("Custom variant has no data-variant-id");
        alert("Sorry, something went wrong. Please try again.");
        return;
      }

      setLoading("Preparing checkout...");

      try {
        const response = await fetch(window.donationApiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            variant_id: variantId,
            amount: amount,
            campaign: campaign,
          }),
        });

        const result = await response.json();

        if (!response.ok || !result.checkoutUrl) {
          throw new Error(result.error || "Failed to create donation");
        }

        if (ctaLabel) ctaLabel.textContent = "Redirecting...";
        window.location.href = result.checkoutUrl;
      } catch (error) {
        console.error("Custom donation failed:", error);
        clearLoading();
        alert("Sorry, something went wrong. Please try again.");
      }

      return;
    }

    // ============ PRESET AMOUNT FLOW ============
    if (!variantId && !sellingPlan) return;

    setLoading("Adding...");

    const body = {
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: { Campaign: campaign },
        },
      ],
    };

    if (sellingPlan) {
      body.items[0].selling_plan = parseInt(sellingPlan, 10);
    }

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(`Cart add failed: ${response.status}`);
      }

      if (ctaLabel) ctaLabel.textContent = "Redirecting...";
      window.location.href = "/checkout";
    } catch (error) {
      console.error("Donation add failed:", error);
      clearLoading();
      alert("Sorry, something went wrong. Please try again.");
    }
  });

  // Restore button if user navigates back via browser history
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      clearLoading();
    }
  });

  // Amount button selection (preset variants and custom label)
  widget.querySelectorAll(".donation_amount").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      // Don't intercept clicks on the input itself - let it focus naturally
      if (e.target.classList.contains("donation_custom_input")) return;

      if (cta.classList.contains("loading")) return;

      activateButton(btn);
    });
  });

  // Custom input: typing or focusing auto-activates the custom variant
  if (customInput && customLabel) {
    customInput.addEventListener("focus", () => {
      if (cta.classList.contains("loading")) return;
      activateButton(customLabel);
    });

    customInput.addEventListener("input", (e) => {
      e.target.value = e.target.value.replace(/\D/g, "");
      // Activate custom on first keystroke (in case focus event was missed)
      if (!customLabel.classList.contains("active")) {
        activateButton(customLabel);
      }
    });

    // Enter key submits
    customInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        cta.click();
      }
    });
  }

  // Toggle one-time / monthly
  const toggleBtns = widget.querySelectorAll(".donation_toggle_btn");
  const slider = widget.querySelector(".donation_toggle_slider");
  const grids = widget.querySelectorAll("[data-grid]");

  toggleBtns.forEach((btn, index) => {
    btn.addEventListener("click", () => {
      if (cta.classList.contains("loading")) return;

      const mode = btn.dataset.mode;

      toggleBtns.forEach((b) => {
        b.classList.remove("active");
        b.setAttribute("aria-selected", "false");
      });
      btn.classList.add("active");
      btn.setAttribute("aria-selected", "true");

      if (slider) {
        slider.style.transform = `translateX(${index * 100}%)`;
      }

      grids.forEach((grid) => {
        if (grid.dataset.grid === mode) {
          grid.removeAttribute("hidden");
        } else {
          grid.setAttribute("hidden", "");
        }
      });

      const visibleGrid = widget.querySelector(
        ".donation_widget_grid:not([hidden])",
      );
      if (visibleGrid) {
        visibleGrid
          .querySelectorAll(".donation_amount")
          .forEach((b) => b.classList.remove("active"));
        // Activate first NON-custom button by default
        const firstBtn = visibleGrid.querySelector(
          ".donation_amount:not(.donation_amount_custom)",
        );
        if (firstBtn) firstBtn.classList.add("active");
      }
    });
  });
}

function initBannerScripts() {
  const $section1 = $(".shopify-section.section:has(.donation_section)");
  if (!$section1.length) return;

  // ─── Scroll-based top offsets ─────────────────────────────
  const defaultTop = 9.375;
  const stickyTop = 6.25;

  function updateTop() {
    if ($(window).scrollTop() > 0) {
      $section1.css("top", stickyTop + "vw");
    } else {
      $section1.css("top", defaultTop + "vw");
    }
  }

  updateTop();
  $(window).off("scroll.initTop").on("scroll.initTop", updateTop);

  // ─── Donation widget ──────────────────────────────────────
  document
    .querySelectorAll(".donation_section")
    .forEach((widget) => initDonationWidget(widget));

  // ─── Countdown timer ──────────────────────────────────────
  $(".dd-countdown__timer").each(function () {
    const $timer = $(this);
    if ($timer.data("countdown-initialized")) return;

    const endDate = new Date($timer.data("end")).getTime();
    if (isNaN(endDate)) {
      console.warn("Countdown: invalid end date on", this);
      return;
    }

    function updateCountdown() {
      const now = new Date().getTime();
      let diff = endDate - now;
      if (diff < 0) diff = 0;

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      $timer.find(".dd-days").text(days);
      $timer.find(".dd-hours").text(("0" + hours).slice(-2));
      $timer.find(".dd-minutes").text(("0" + minutes).slice(-2));
      $timer.find(".dd-seconds").text(("0" + seconds).slice(-2));
    }

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    $timer.data("countdown-initialized", interval);
  });
}

$(document).ready(function () {
  initBannerScripts();
});

// ─── Session attribute tracker ──────────────────────────────
(function () {
  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      session: params.get("session"),
      amount: params.get("amount"),
    };
  }

  async function saveSessionToCart(session, amount) {
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: {
            donation_session: session,
            donation_amount: amount,
          },
        }),
      });

      const result = await response.json();
      console.log("Cart updated:", result);
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  }

  document.addEventListener("DOMContentLoaded", async function () {
    const { session, amount } = getUrlParams();
    if (!session) return;
    await saveSessionToCart(session, amount);
  });
})();